import React, { Fragment, memo } from 'react'
import map from 'ramda/src/map'
import Anchor from 'root/src/client/web/base/Anchor'
import pageContent from './pageContent'

const Anchors = memo(({ classes }) => (
	<div className={classes.listWrapper}>
		{map(({ sectionTitle, id, items }) => (
			<Fragment>
				<Anchor anchor={id}>{sectionTitle}</Anchor>
				<ul className={classes.listOfLinks}>
					{map(({ title, id: subSectionId }) => (
						<li>
							<Anchor anchor={subSectionId}>{title}</Anchor>
						</li>
					), items)}
				</ul>
			</Fragment>
		), pageContent)}
	</div>
))

export default Anchors
